module.exports = __webpack_public_path__ + "static/media/300_14.46388e71.jpg";